import React, { useState, useEffect } from 'react';
import icons from '../../utils/icons.json';
import { useDispatch, useSelector } from 'react-redux';
import { imgCheck } from '../../utils/fn';
import { addCartItems, removeCartItem } from '../../store/cartItems';
import { useNavigate } from 'react-router-dom';
// import img from '../../assets/cart2.png';
import img from '../../assets/product-placeholder.png';
import { setAlert } from '../../store/alert';
import { addFavorite, removeFavorite } from '../../store/favorites';
import { motion } from 'framer-motion';

function Product({ data }) {
	const webSettings = useSelector((state) => state.webSettings.data);
	const dispatch = useDispatch();
	const navigate = useNavigate()

	const cartItems = useSelector((state) => state.cartItems.data);
	const favorites = useSelector((state) => state.favorites.data);

	const [isCartItem, setIsCartItem] = useState(false);
	const [isFavorite, setIsFavorite] = useState(false);
	const [thumbnail, setThumbnail] = useState(null);




	useEffect(() => {
		imgCheck(data.src[0], img).then((src) => setThumbnail(src));
	}, [data]);

	useEffect(() => {
		//setToStore(constants.CART_ITEMS, cartItems);
		let found = false;
		cartItems.forEach((item) => {
			if (item.item_code === data.item_code) {
				found = true;
			}
		});
		setIsCartItem(found);
	}, [cartItems]);

	useEffect(() => {
		let found = false;
		favorites.forEach((item) => {
			if (item.item_code === data.item_code) {
				found = true;
			}
		});
		setIsFavorite(found);
	}, [favorites]);

	function viewProduct() {
		navigate('/product/' + data.itemURL, {
			state: { product: data }
		});
	}

	function addToCart(e) {
		// we will check if the product is already in the cart and render appropriately.
		dispatch(addCartItems([{ ...data, quantity: data.quantity || 1 }]));
		dispatch(setAlert('Item added to Cart'));
	}

	function removeFromCart() {
		dispatch(removeCartItem(data.item_code));
		dispatch(setAlert({ type: 'warning', message: 'Item removed from Cart' }));
	}

	function addToFavorite() {
		dispatch(addFavorite(data));
	}

	function removeFromFavorite() {
		dispatch(removeFavorite(data.item_code));
	}

	return (
		<motion.div layout className="each-product">
			<div className="inner"></div>
			<div onClick={viewProduct} className="img-preview" style={{ backgroundImage: `url(${thumbnail})` }}>
				{thumbnail == null && <span dangerouslySetInnerHTML={{ __html: icons.sm_spinner }}></span>}
				{/* {thumbnail == null && <img src={require("./../../assets/cart.jpg")} />} */}
			</div>
			<div onClick={viewProduct} className="details">
				<p className="item-name ellipsis">{data.item_name}</p>
				<p className="item-price">
					{webSettings.CURRENCY} {data.price}<br />
					<div className='discountprice'>{webSettings.CURRENCY} {parseInt(data?.amount_value) + 300}</div>
				</p>
			</div>
			<section className="footer">
				{isCartItem && (
					<button
						onClick={removeFromCart}
						className="flex btn remove"
						dangerouslySetInnerHTML={{ __html: icons.shopping_cart + 'Remove' }}
						style={{
							color: webSettings.CART_BUTTON_COLOR,
							fill: webSettings.CART_BUTTON_COLOR,
							border: '1px solid ' + webSettings.CART_BUTTON_COLOR,
						}}
					/>
				)}
				{!isCartItem && (
					<button
						onClick={addToCart}
						className="flex btn"
						dangerouslySetInnerHTML={{ __html: icons.cart_plus + webSettings.WEB_CART_TEXT }}
						style={{
							background: webSettings.CART_BUTTON_COLOR,
							fill: 'white',
							color: 'white',
							border: 'none',
						}}
					/>
				)}
			</section>
			<button
				title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
				onClick={() => (isFavorite ? removeFromFavorite() : addToFavorite())}
				className={'fav-btn' + (isFavorite ? ' active' : '')}
				dangerouslySetInnerHTML={{ __html: isFavorite ? icons.heart_filled : icons.heart }}
			></button>
		</motion.div>
	);
}

export default React.memo(Product);
